module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-metals.2058fc6f.png";